<template>
  <!-- 发起审批，审批流展示 -->
  <div class="workflow">
    <!-- 添加抄送人 -->
    <div class="pupCon">
      <!-- <van-search shape="round" placeholder="搜索" v-model="searchTxt" /> -->
      <van-checkbox-group v-model="result" @change="getTree">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in list"
            clickable
            :key="item.UserID"
            :title="`${item.FullName}`"
            @click="toggle(index)"
          >
            <van-checkbox :name="item" ref="checkboxes" slot="icon" style="margin-right:12px;" />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="foot-btn">
        <div class="num-box fl">
          <div class="num-select">
            <img class="num-icon" src="@/assets/infoPublic/images/like@2x.png" />
            <span class="num-like">已选择</span>
          </div>
          <span class="num-text" v-if="storeBarData[addCCIndex].CCUsers!==undefined">
            <span>{{storeBarData[addCCIndex].CCUsers.length + result.length}}</span>人
          </span>
        </div>
        <van-button round type="info" class="num-sure fr" @click.native="Submission">确定</van-button>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "coperUser",
  props: {},
  data() {
    return {
      searchTxt: "",
      list: [],
      result: [],
      newBarData: [],
      id:'',
      type:'',
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.type = this.$route.params.type;
    this.getUserList();
  },
  computed: {
    leaveTeachers () {
      return this.$store.state.attendance.leaveTeachers
    },
    addCCIndex () {
      return this.$store.state.attendance.addCCIndex
    },
    storeBarData () {
      return this.$store.state.attendance.barData
    }

  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },

    async getUserList() {
      this.xy.loading()
      let params = {
        orgID: this.id,
        type: this.type,
        teacherIDs:'',
      }
      let res = await this.xyapi.get(this.xyMApi + "/xy/Comm/GetNodeListHasmember", params);
      this.xy.unloading()
      if (res.success) {
        this.list = res.data[0].memberlist.map(item=>{
          return {
            UserID: item.UserID,
            FullName: item.FullName,
            DisplayName:'抄送',
          }
        })
      }
    },

    getTree() {

    },
    Submission() {
      this.$store.commit("attendance/addLeaveTeachers", {index: [this.addCCIndex], list: this.result});
      console.log(this.result)
      let barData = this.$store.state.attendance.barData;
      this.result.map(item=>{
        barData[this.addCCIndex].CCUsers.push(item)
      })
      var resultaa = [];
      var obj = {};
      // 去重
      for (var i = 0; i < barData[this.addCCIndex].CCUsers.length; i++) {
          if (!obj[barData[this.addCCIndex].CCUsers[i].UserID]) {
              resultaa.push(barData[this.addCCIndex].CCUsers[i]);
              obj[barData[this.addCCIndex].CCUsers[i].UserID] = true;
          }
      }
      barData[this.addCCIndex].CCUsers = resultaa
      this.$store.commit('attendance/setBarData', barData)
      this.$router.push({name: "TeacherLeaveCreate", query:{isBack: true}});
    }
  },
};
</script>

<style lang="less" scoped>
  .workflow {
    padding-bottom: 140px;
  }
.pupCon {
  width: 100%;
  background-color: #fff;
  .title {
    text-align: center;
    line-height: 100px;
    font-size: 32px;
  }
  .msg {
    color: #666666;
    text-align: left;
    line-height: 20px;
    font-size: 22px;
    text-indent: 30px;
  }
  .leaveType {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    div {
      flex: inherit;
      text-align: -webkit-center;
    }
    div > h1 {
      display: block;
      height: 66px;
      width: 66px;
      line-height: 66px;
      background-color: #4196ff;
      border-radius: 50%;
      font-size: 12px;
      color: #ffffff;
      margin-left: 30px;
    }
    div > p {
      font-size: 12px;
      margin-left: 30px;
      line-height: 60px;
    }
    .add {
      width: 66px;
      height: 66px;
      background: rgba(255, 255, 255, 1);
      background-image: url(../../assets/common/addpig.png);
      background-size: 66px 66px;
      border-radius: 50%;
    }
  }
}
.foot-btn {
  height: 140px;
  background: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.foot-btn > .num-box {
  width: 230px;
  height: 90px;
  background: #f2f2f2;
  border-radius: 0 45px 45px 0;
  margin-top: 26px;
}

.foot-btn > .num-box > .num-select {
  display: block;
  margin-left: 48px;
  margin-top: 20px;
}
.foot-btn > .num-box > .num-select > .num-icon {
  display: inline-block;
  width: 36px;
}
// .foot-btn > .num-box > .num-select > .num-like {
// }

.foot-btn > .num-box > .num-text {
  display: block;
  margin-left: 48px;
  color: #040404;
  font-size: 28px;
  font-weight: bold;
}
.foot-btn > .num-box > .num-text > span {
  color: #040404;
  font-size: 20px;
}
.foot-btn > .num-sure {
  width: 220px;
  height: 74px;
  font-size: 32px;
  margin-top: 38px;
  margin-right: 32px;
}
</style>
